module.exports = __webpack_public_path__ + "funding2-6e4d24ec79376912966598cf48604100.png";